var plan_lists = [7,8,9,11,12];
$('.buy_tab>div span').click(function(){
    $(this).addClass('active').siblings().removeClass('active')
    $('.buy_main .buy_box').eq($(this).index()).addClass('active').siblings().removeClass('active')
})

$('.table_main .show_table').click(function(){
    $(this).toggleClass('active')
    $(this).next().find('table').toggleClass('active')
})
$('.faq_box>div .title').click(function(){
    $(this).parent().toggleClass('active').siblings().removeClass('active')
})
function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
}
var buy_first=0;
var isbuy=0;
window.open_google = true;
// ga跟踪代码
function gaPush(dataEvent,lable){
    try{
        // _gaq.push(['_trackEvent',operation,String(dataEvent),String(lable)]);
    }catch(e){
        // console.log(e)
    }
}
// 判断是否首次进入页面
if(localStorage.getItem('buy_first')){
    buy_first=1
}else{
    localStorage.setItem('buy_first',1)
}
if(location.hostname=='www.vidhex.ai'
){
    var paddle_vendor=183001;
    var fast_storefront='vidhexai.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}else{
    // Paddle.Environment.set('sandbox');
    var paddle_vendor=570;
    var fast_storefront='vidhexai.test.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}
var fastspringScript
// 请求购买链接
$('.buy_box .btn').click(function(){
    if($(this).attr('class').indexOf('load')>-1){
        return false;
    }
    checkout($(this));
});
function checkout(that){
    var data={
        e_id:murmur,
        gateway:gateway,
        plan_id:that.attr('plan'),
    }
    gaPush('buy_fail','buy_planID',that.attr('plan'))
    that.addClass('load')
    $.post(
        post_url+"subscription/checkout",
        data,
        function(data){
            error_fn(data.error,that);
            switch(data.error){
                case 0:
                    if(gateway==4){
                        // 2checkout
                        (function (document, src, libName, config,data) {
                            var data=getUrlkey(data.url_gateway)
                            var script             = document.createElement('script'); 
                            script.src             = src; 
                            script.async           = true; 
                            script.id              ='buy2checkout'
                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                            script.onload          = function () {
                                $('.buy_box .btn').removeClass('load');
                                var isbuy=0;
                                for (var namespace in config) {
                                    if (config.hasOwnProperty(namespace)) {
                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                    } 
                                } 
                                window[libName].register();
                                TwoCoInlineCart.products.add({
                                    code: data.prod,
                                    quantity: data.qty,
                                });
                                try{
                                    if(data.test){
                                        TwoCoInlineCart.cart.setTest(true);
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                                if(data.lock){
                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                }else{
                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                }
                                if(data['empty-cart']){
                                    TwoCoInlineCart.cart.setReset(true)
                                }else{
                                    TwoCoInlineCart.cart.setReset(false)
                                }
                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                TwoCoInlineCart.cart.setSignature(data.signature)
                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                TwoCoInlineCart.cart.checkout();
                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                    console.log('cart:opened')
                                })
                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                    if(isbuy){
                                        $('.maskRights').show();
                                        if(getCookie('user')){
                                            $('.buySuccess.Member').show().siblings().hide();
                                            gaPush('buy_login','true')
                                        }else{
                                            $('.buySuccess.noMember').show().siblings().hide();
                                            gaPush('buy_login','false')
                                        }
                                    }
                                })
                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                    isbuy=1;
                                    gaPush('buy_success','')
                                })
                            }; 
                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                    }else if(gateway==6){
                        $('.maskRights').show()
                        if(getCookie('user')){
                            $('.buySuccess.Member').show().siblings().hide();
                        }else{
                            $('.buySuccess.noMember').show().siblings().hide();
                        }
                        console.log("3",newWindow);
                        newWindow.location.href = data.url_gateway;
                    }else if(gateway==7){
                        var key=JSON.parse(window.atob(data.url_gateway.split('base64,')[1]));
                        console.log(key);
                        isbuy=0;
                        if(fastspringScript){
                            $('.buy_box .btn').removeClass('load');
                            fastspring.builder.secure(key.p,key.k)
                            fastspring.builder.checkout();
                        }else{
                            fastspringScript=document.createElement('script'); 
                            fastspringScript.src="https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js"; 
                            fastspringScript.async=true; 
                            fastspringScript.id='fsc-api'
                            fastspringScript.setAttribute('data-storefront',fast_storefront)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-popup-closed','dataPopupClosed')
                            fastspringScript.setAttribute('data-popup-webhook-received','dataPopupWebhookReceived')
                            document.body.appendChild(fastspringScript)
                            fastspringScript.onload=function(){
                                $('.buy_box .btn').removeClass('load');
                                fastspring.builder.secure(key.p,key.k)
                                fastspring.builder.checkout();
                            }
                        }
                    }else{
                        // isbuy=0;
                        // Paddle.Checkout.open({
                        //     override: data.url_gateway
                        // });
                    }
                    break
                case 25301:
                    that.removeClass('load')
                    error(i18n[lang].error_25301);
                    break;
                case 25302:
                    that.removeClass('load')
                    error(i18n[lang].error_25302);
                    break;
                case 25303:
                    that.removeClass('load')
                    error(i18n[lang].error_25303);
                    break;
                case 25304:
                    that.removeClass('load')
                    error(i18n[lang].error_25304);
                    break;
                case 25305:
                    that.removeClass('load')
                    error(i18n[lang].error_25305);
                    break;
                case 25306:
                    that.removeClass('load')
                    error(i18n[lang].error_25306);
                    break;
            }
        }
    ).error(function(xhr){
        that.removeClass('load')
        overtime(25399);
    });
}
// fastspring关闭回调
function dataPopupClosed(){
    if(isbuy){
        if(user){
            $('.buySuccess.Member').show();
            $('.buySuccess.noMember').hide();
            $('.buyInner .mailto').text(personal.email)
            gaPush('buy_login','true')
        }else{
            $('.buySuccess.noMember').show();
            $('.buySuccess.Member').hide();
            gaPush('buy_login','false')
        }  
    }
}
// fastspring购买成功回调
function dataPopupWebhookReceived(){
    isbuy=1;
}
$('.need_more').on('click',function(){
    $('.customer_zoon').addClass('active');
    $('body').addClass('hide');
});
$('.customer_zoon .close').on('click',function(){
    $('.customer_zoon').removeClass('active');
    $('body').removeClass('hide');
});
//邮箱正则判断
var reg_email = /^[a-zA-Z0-9.!#$%&#$%&amp; '*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var email_flag = true;
var textarea_flag = false;
// email框
$('.customer_zoon .email').blur(function(){
    var value = $(this).val().trim();
    $(this).val(value);
    if(!$(this).val()){
        //判断是否邮箱为空
        $(this).addClass('error');
        $(this).next().html('Please input your email');
        email_flag = false;
        return false;
    }else if(!reg_email.test($(this).val())){
        //正则判断格式是否正确
        $(this).addClass('error');
        $(this).next().html('Email is not valid');
        email_flag = false;
        return false;
    }else{email_flag = true}
});
$('.customer_zoon .email').focus(function(){
    $(this).removeClass('error');
    let value=$(this).val().replace(/(^\s*)|(\s*$)/g, "");
    $(this).val(value);
});
$('.customer_zoon .suggestion').on('input',function(){
    let value=$(this).val().replace(/(^\s*)|(\s*$)/g, "");
    if (value === '') {
        $('.error_tips').removeClass('hide');
        $('.error_tips .ber').removeClass('active');
        $('.tips_error').addClass('hide');
        textarea_flag = false;
    } else if (value.length <= 2) {
        $('.error_tips').removeClass('hide');
        $('.error_tips .ber').removeClass('active');
        $('.tips_error').addClass('hide');
        textarea_flag = false;
    } else if (value.length >= 200) {
        $('.error_tips').removeClass('hide');
        $('.error_tips .ber').addClass('active');
        $('.tips_error').removeClass('hide');
        textarea_flag = false;
    } else {
        // $('.error_tips').addClass('hide');
        $('.error_tips .ber').removeClass('active');
        $('.tips_error').addClass('hide');
        textarea_flag = true;
    };
    $('.error_tips .ber').text(value.length);
});
$('.customer_zoon .submit').on('click',function(){
    if(!$('.customer_zoon .info input').prop('checked')){
        $('.customer_zoon .info input').addClass('shaking');
        return false;
    }else if (!textarea_flag){
        return false;
    }else if (!email_flag){
        $('.customer_zoon .email').removeClass('shaking').addClass('shaking');
        return false;
    }else{
        $.post('https://www.vidhex.ai/api/credits-support.php',{
            email:$('.customer_zoon .mail').val(),
            content:$('.customer_zoon .suggestion').val(),
        },function(res){
            if(res.error==0){
                $('.form_success .title').text('Success!');
                $('.form_success .info').text('Your custom points request has been processed. A confirmation email will be sent to your registered email address. Please check your inbox.');
                $('.form_success').show();
                $('.customer_zoon').removeClass('active');
            }else{
                $('.form_success .title').text('Delivery Failed. ');
                $('.form_success .info').text(`Our system encountered an error while processing your request. Please verify your email address and try again, or contact <a href="mailto:support@vidhex.ai">support@vidhex.ai</a> for assistance.`);
                $('.form_success').show();
                $('.customer_zoon').removeClass('active');
            }
        });
    }
});
$(document).ready(function(){
    if(window.location.search != ''){
      var value = getQueryVariable('plan_id');
      for(var j=0;j<$('.buy_main span.btn').length;j++){
        if($('.buy_main span.btn').eq(j).attr('attr-plan')==value){
            checkout($('.buy_main span.btn').eq(j));
        }
      }
    }
});
$('.buySuccess .close,.buySuccess .got').on('click',function(){
    $('.buySuccess').hide();
});